import * as React from 'react';

/**
 * Hook that returns the previous value of the given parameter
 */
const usePrevious = <T>(value: T) => {
    const ref = React.useRef<T>();

    React.useEffect(() => {
        ref.current = value;
    });

    return ref.current as T;
};

export default usePrevious;
